export default function ContactUs() {
  return (
    <div>
      <h2>Contact us</h2>
      <p style={{ opacity: 0.75 }}>Contact options are coming soon.</p>
    </div>
  );
}
